import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Header from "components/Header/Header";
import useCart from "hooks/useCart";
import CheckoutPaymentOptions from "containers/Checkout/CheckoutPaymentOptions/CheckoutPaymentOptions";
import CheckoutVmCard from "containers/Checkout/CheckoutVmCard/CheckoutVmCard";
import Button from "components/Button/Button";
import useRazorpay from "hooks/useRazorpay";
// import usePaytm from "hooks/usePaytm";
import useCasefree from "hooks/useCasefree";
import useAuthentication from "hooks/useAuthentication";
import CheckoutPaymentStatus from "containers/Checkout/CheckoutPaymentStatus/CheckoutPaymentStatus";
import AlertModal from "components/AlertModal/AlertModal";
import CouponInputBox from "containers/CartOverview/CouponInputBox/CouponInputBox";
import withToasts from "hoc/withToasts";
import { API_KEYS } from "constants/apiEndpoints";
import { LeftArrowIcon } from "constants/icons";
import { APP_ROUTES } from "constants/routes";
import { requestPostFetchApi } from "utils/apiMethods";
import { PAYMENT_METHODS, VM_STATUS_ONLINE } from "constants/constants";
import "containers/Checkout/Checkout.css";
//Handles checkout page.
function Checkout({ history, showErrorToast }) {
  const vendingMachineDetails = useSelector((state) => state.vmDetailsReducer);
  const [showLoader, setShowLoader] = useState(true);
  const [showPaymentStatusModal, setShowPaymentStatusModal] = useState(false);
  const [cartItemsNotValidated, setCartItemsNotValidated] = useState(null);
  const { currentCartItems, validateCartItems } = useCart();
  const cartCouponDetails = useSelector(
    (state) => state.cartReducer.couponDetails
  );

  const triggerPaymentStatusModal = function (failure = false) {
    return setShowPaymentStatusModal({ failure });
  };
  //Constants.
  const DEFAULT_PAYMENT_METHOD = PAYMENT_METHODS.CARD.code;
  const componentTexts = window.appTexts.checkout_page;
  const cUID = useSelector((state) => state.orderReducer.cUID); //Cart Unique Identifier

  const syncCartApiCall = function (order_id, gatewayOID, failure = false) {
    return requestPostFetchApi(API_KEYS.SYNC_CART, {
      device_uuid: vendingMachineDetails.uuid,
      order_id,
      sync: {
        gateway_order_id: gatewayOID,
        payment_status: !failure,
      },
    });
  };

  const onPaymentSuccess = function (cUID, backendOrderId, gatewayOID) {
    // triggerPaymentStatusModal();
    // return syncCartApiCall(backendOrderId, gatewayOID).then(() => {
    return history.push(
      APP_ROUTES.DISPENSING_ITEMS.rawUrl + backendOrderId + "/" + cUID
    );
    // });
  };

  const onPaymentFailure = function (backendOrderId, gatewayOID) {
    triggerPaymentStatusModal(true);
    // return syncCartApiCall(backendOrderId, gatewayOID, true);
  };

  // Hooks for Razorpay Gateway.
  const [activateRazorpayModal] = useRazorpay(
    cUID,
    onPaymentSuccess,
    onPaymentFailure
  );

  // Hooks for Paytm Gateway.
  // const [activatePaytmModal] = usePaytm(
  //   cUID,
  //   onPaymentSuccess,
  //   onPaymentFailure
  // );

  //Hooks for Casefree Gateway.
  const [activateCasefreeModal] = useCasefree(
    cUID,
    onPaymentSuccess,
    onPaymentFailure
  );

  const { getUserId } = useAuthentication();

  const vendingMachineId = useSelector((state) => state.vmDetailsReducer.id);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(
    DEFAULT_PAYMENT_METHOD
  );

  //Checking VM online status whether its true or false
  let vendingMachineStatus = useSelector(
    (state) => state.vmDetailsReducer.is_online
  );

  //Cart validations.
  useEffect(() => {
    if (currentCartItems.length > 0) {
      let items = currentCartItems.map((element) => ({
        product_id: element.item.iUID,
        product_quantity: element.quantity,
        sid: element.item.sid,
      }));

      //API request.
      requestPostFetchApi(API_KEYS.VALIDATE_CART_ITEMS, {
        vendingMachineId,
        items,
      }).then((response) => {
        let itemsUnableToDispense = null;
        setShowLoader(false);
        if ((itemsUnableToDispense = validateCartItems(response))) {
          return setCartItemsNotValidated(itemsUnableToDispense);
        }
      });
    } else {
      setShowLoader(false);
    }
  }, []);

  //Validates cart item
  useEffect(() => {
    return () => {
      if (window.paymentObject && window.paymentObject.close) {
        window.paymentObject.close();
      }
    };
  }, [currentCartItems, vendingMachineId]);

  let createApiPayload = {
    cUID,
    id: vendingMachineDetails.id,
    items: currentCartItems.map((element) => ({
      iQty: element.quantity,
      iUID: element.item.iUID,
      sid: element.item.sid,
    })),
    uuid: vendingMachineDetails.uuid,
    transaction_origin: 2,
  };

  if (cartCouponDetails) {
    createApiPayload.coUID = cartCouponDetails.coUID;
    createApiPayload.coState = cartCouponDetails.coState;
  }

  //If VM status is not online
  if (vendingMachineStatus !== true) {
    return (
      <AlertModal
        open={true}
        modalTitle={VM_STATUS_ONLINE.TITLE}
        modalDescription={VM_STATUS_ONLINE.DESCRPTION}
      ></AlertModal>
    );
  }

  //Handles payment
  const submitHandler = function (response) {
    // if (response.payment_gateway === 1) {
    //   // Activates Paytm Modal

    //   return activatePaytmModal(
    //     response.fVal,
    //     response.gatewayOID,
    //     response.order_token,
    //     selectedPaymentMethod,
    //     response.oUID
    //   );
    // } else
    if (response.payment_gateway === 2) {
      // Activates razorpay modal.

      return activateRazorpayModal(
        response.fVal,
        response.gatewayOID,
        selectedPaymentMethod,
        response.oUID
      );
    } else {
      //Activates Casefree Modal

      return activateCasefreeModal(
        response.fVal,
        response.order_token,
        selectedPaymentMethod,
        response.oUID
      );
    }
  };

  //Finalize the create api payload.
  (function finalizeCreateApiPayload() {
    let userId = null;

    //Send customer id if user is logged in.
    if ((userId = getUserId())) {
      createApiPayload.customerId = Number(userId);
    }

    createApiPayload.time = new Date().getTime();
    createApiPayload.payMethod = selectedPaymentMethod;
  })();

  if (showLoader) {
    return (
      <div className="center-screen-grid">
        <span>{componentTexts.getting_things_ready}</span>
        <div className="loading-dots"></div>
      </div>
    );
  }
  //If no item can dispense,show alert
  if (cartItemsNotValidated && cartItemsNotValidated.length === 0) {
    return (
      <AlertModal
        open={true}
        modalTitle={componentTexts.unable_to_dispense_title}
        modalDescription={componentTexts.unable_to_dispense_desc}
      >
        <Link to={APP_ROUTES.HOME_PAGE.url}>
          <Button className="mt-1">Go To Dashboard</Button>
        </Link>
      </AlertModal>
    );
  }

  //If no items in cart, redirect to homepage.
  if (currentCartItems.length === 0) {
    history.push(APP_ROUTES.HOME_PAGE.url);
    return <React.Fragment></React.Fragment>;
  }

  return (
    <div id="checkout_container">
      {" "}
      {!showPaymentStatusModal ? (
        <div className="checkout-sub-container">
          <Header className="checkout-page__header">
            <div className="checkout__page-title">
              <Link to={APP_ROUTES.CART_PAGE.url}>
                <i>
                  <LeftArrowIcon />
                </i>
              </Link>
              <span>{componentTexts.checkout_page_title}</span>
            </div>
            <div></div>
          </Header>
          <section className="checkout-page">
            <CheckoutVmCard
              componentTexts={componentTexts}
              itemsUnableToDispense={cartItemsNotValidated}
            />
            <CouponInputBox id={cUID} showErrorToast={showErrorToast} />
            <h3 className="checkout-page__payment-option-heading">
              {
                componentTexts.checkout_payment_options
                  .checkout_payment_options_heading
              }
            </h3>
            <CheckoutPaymentOptions
              componentTexts={componentTexts.checkout_payment_options}
              selectedPaymentMethod={selectedPaymentMethod}
              setSelectedPaymentMethod={setSelectedPaymentMethod}
            />
            <Button
              loaderApiKey={API_KEYS.CREATE_CART}
              apiRequestBody={createApiPayload}
              onClick={submitHandler}
            >
              {componentTexts.checkout_page_button_text}
            </Button>
          </section>
        </div>
      ) : (
        <CheckoutPaymentStatus failure={showPaymentStatusModal.failure} />
      )}
    </div>
  );
}

Checkout.propTypes = {
  history: PropTypes.object.isRequired,
};

export default withToasts(Checkout);
